export const constants =
{
  APP_RUNTIME_CONFIG: '/assets/runtime.config.json',
 // storage: {
 //   STORAGE_CLIENT_NAME: 'client',
 //   PAGE_PARAMS: 'params',
 //   COMPANY_PARAMS: 'companyInfo',
 //   STORAGE_USER: 'currentUser',
 //   STORAGE_COOKIES_ACCEPTED: 'cookiesAccepted',
 //   STORAGE_CART_ID: 'cartId',
 //   STORAGE_CART_DATA: 'cartData',
 //   STORAGE_MENU: 'CategoriesMenu'
 // },
  config: {
    userLogin: '/login/user-login',
    recoverPassword: 'login/recover-password',

  }
};
